export default __webpack_public_path__ + "static/media/roof_repair.909521da.svg";